export const webImageUrl = (image: string) => {
  return `${process.env.REACT_APP_API_BASE_URL}${image}`;
};
